﻿//If you change these, change the C# version as well. Wouldn't it be nice if we could inject these values to JS from C#?
export const DateFormat: string = "M/d/yyyy";
export const TimeFormat: string = "h:mm tt";
export const DateTimeFormat: string = `${DateFormat} ${TimeFormat} CT`;
export const KendoDateFormat: string = `{0:${DateFormat}}`;
export const KendoMoneyFormat: string = "{0:C}";
export const KendoPercentageFormat: string = "{0:p}";
export const ProductName = "Opus Portal";